<template>
  <section id="services" class="services mbr-box mbr-section mbr-section--relative mbr-section--fixed-size mbr-section--full-height mbr-section--bg-adapted mbr-parallax-background">
		<div class="section-overlay"></div>
		<div class="container">
			<div class="row center">
				<div class="col-md-8 col-md-offset-2 col-sm-12">
					<div class="section-title-parralax">
						<div class="process-numbers">02</div>
						<h2>services</h2>
						<p class="module-subtitle">I am passionate about what I do and I believe it reflects in the quality of my work.
						</p>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 right col-full right-0">
					<i class="lnr lnr-users"></i>
					<h6>User Experience</h6>
					<p>I design user friendly, intuitive interfaces allowing 
						<br>users to focus on the task and not the tool.
					</p>
				</div>
				<div class="col-lg-6 left col-full left-0">
					<i class="lnr lnr-laptop-phone"></i>
					<h6>design &amp; development</h6>
					<p>I develop fast interactive front ends, using the 
						<br>latest technologies and techniques to reduce page load time.
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-6 right col-full right-0">
					<i class="lnr lnr-chart-bars"></i>
					<h6>RESEARCH</h6>
					<p>I use my knowledge and tools to save 
						<br>time in development
					</p>
				</div>
				<div class="col-lg-6 left col-full left-0">
					<i class="lnr lnr-smartphone"></i>
					<h6>Mobile first</h6>
					<p>Functional mobile first design,
						<br>built in a flexible grid framework
					</p>
				</div>
			</div>
		</div>
	</section>

</template>

<script>
export default {
  name: "Services",
  data() {
    return {
      msg: ""
    };
  }
};
</script>



<style scoped>
section#services {
  background-image: url("/static/assets/img/background.gif");
}
</style>



// WEBPACK FOOTER //
// src/components/Services.vue